import React from "react";
import { Dropdown } from "components/ui";
import { ReactSVG } from "react-svg";
import asset from "assets/images";
import { ISSUES_PERMS_ACTIONS } from "../../enum";
import { baseResources, baseResourceActions } from "routes/enum";

const { KB_SAM_ISSUE_CONVERSATION } = baseResources;
const { UPDATE, DELETE } = baseResourceActions;

const IssuesTableDropdown = ({ issue, handleActionModal }) => {
    return (
        <Dropdown
            size='sm'
            placeholder={
                <ReactSVG
                    src={asset?.icons?.horizontalEllipsis}
                    className='d-inline-flex'
                />
            }
            ddValueClass='borderless'
            className='table__dropdown'
            ddOptionsClass='table__dropdown'
            anchor={false}
            changeValue={false}
            onChange={({ value }) => handleActionModal(value, issue)}
            options={[
                {
                    value: ISSUES_PERMS_ACTIONS.EDIT_ISSUE,
                    label: "Edit Issue",
                    baseResources: [`${UPDATE}_${KB_SAM_ISSUE_CONVERSATION}`],
                },
                {
                    value: ISSUES_PERMS_ACTIONS.DELETE_ISSUE,
                    label: "Delete Isssue",
                    baseResources: [`${DELETE}_${KB_SAM_ISSUE_CONVERSATION}`],
                },
            ]}
        />
    );
};

export default IssuesTableDropdown;
